import { Component, Inject } from '@angular/core';
import { MembersService } from '../../services/members.service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { EMAIL_REGEX } from '../../helpers/regex';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SnackbarService } from '../../services/snackbar.service';

@Component({
  selector: 'prism-member-state',
  templateUrl: './member-state.component.html',
  styleUrls: ['./member-state.component.scss']
})
export class MemberStateComponent {
  stateAction: string;
  emailFormGroup: FormGroup;

  constructor(
    private memberService: MembersService,
    @Inject(MAT_DIALOG_DATA) public data: { stateAction: string },
    public dialogRef: MatDialogRef<MemberStateComponent>,
    private snackbarService: SnackbarService
  ) {
    this.stateAction = data.stateAction;
    this.emailFormGroup = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.pattern(EMAIL_REGEX)])
    });
  }

  onSubmit() {
    let memberData = {
      loginEmail: this.emailFormGroup.value,
      actionType: this.stateAction
    };
    this.memberService.changeMemberState(memberData).subscribe((responseData: any) => {
      this.snackbarService.showSnackbar(responseData.message);
    });

    this.dialogRef.close();
  }
}
